/* BSRATE-TRANS-002 — prechargement des chunks de route au survol de la sidebar.
 *
 * Chaque page est un chunk lazy (voir les lazy(...) dans App.js). Au premier clic
 * vers une section non chargee, React.lazy suspend => spinner. En rejouant le meme
 * import() ici au survol du lien, webpack telecharge le chunk a l'avance (il dedoublonne
 * par module) : quand React.lazy l'appelle ensuite, la promesse resout instantanement,
 * donc plus de suspension => crossfade fluide des le premier clic.
 *
 * IMPORTANT : garder ces chemins d'import strictement identiques a ceux d'App.js
 * (meme fichier => meme chunk). Ce module vit a la racine src/ pour cette parite. */

// ResultsLayout est le shell de /results/* : le precharger avec la page enfant.
const prefetchResultsShell = () => import('./components/Analytics/ResultsLayout');

const prefetchers = {
  '/dashboard': () => import('./pages/Dashboard'),

  // Enquetes
  '/surveys/mine': () => import('./pages/MySurveys'),
  '/surveys/create': () => import('./pages/EnqueteWizard'),
  '/surveys/templates': () => import('./pages/Modeles'),

  // Resultats (+ shell ResultsLayout)
  '/results/overview': () => { prefetchResultsShell(); return import('./components/Analytics/DashboardOverview'); },
  '/results/insights': () => { prefetchResultsShell(); return import('./components/Analytics/InsightsPage'); },
  '/results/critical-points': () => { prefetchResultsShell(); return import('./components/Analytics/RiskAlerts'); },
  '/results/action-plan': () => { prefetchResultsShell(); return import('./components/ActionPlan/ActionPlanPage'); },
  '/results/analysis': () => { prefetchResultsShell(); return import('./components/Analytics/AnalysisPage'); },

  // Organisation
  '/organization/employees': () => import('./pages/Employees'),
  '/organization/teams': () => import('./pages/placeholders/TeamsPage'),
  '/organization/managers': () => import('./pages/placeholders/ManagersPage'),

  // Benchmark
  '/benchmark': () => import('./components/Analytics/BenchmarkDashboard'),

  // Parametres
  '/settings/account': () => import('./pages/MyAccount'),
  '/settings/company': () => import('./pages/Settings'),
  '/settings/billing': () => import('./pages/placeholders/SettingsBilling'),
  '/settings/users': () => import('./pages/SettingsUsers'),

  // Aide
  '/help': () => import('./pages/Help'),

  // Back-office plateforme (SPEC §5) — mêmes chemins d'import que App.js.
  '/platform/companies': () => import('./pages/platform/PlatformCompanies'),
  '/platform/audit': () => import('./pages/platform/PlatformAudit'),
};

// Best-effort : jamais d'erreur remontee a l'UI (href inconnu ou echec reseau => no-op).
export function prefetchRoute(href) {
  const load = prefetchers[href];
  if (!load) return;
  try {
    const p = load();
    if (p && typeof p.catch === 'function') p.catch(() => {});
  } catch (_) {
    /* no-op : le prechargement est purement opportuniste */
  }
}
